import { render } from "./AllowPayment.vue?vue&type=template&id=1e4ac41a"
import script from "./AllowPayment.vue?vue&type=script&lang=js"
export * from "./AllowPayment.vue?vue&type=script&lang=js"

import "./AllowPayment.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__